import { NotebookPenIcon } from "lucide-react";
import { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/Base/Popover";
import { Card } from "@/types/v2";
import { Notes } from "./Notes";
import { Badge } from "@/components/Base/Badge";
import { cn } from "@/lib/utils";

export interface NotesPopoverProps {
  cardData: Card;
  disabled?: boolean;
  shopId: string;
  iconSize?: number;
}
export const NotesPopover = ({
  cardData,
  shopId,
  disabled,
  iconSize = 14,
}: NotesPopoverProps) => {
  const [open, setOpen] = useState(false);

  if (!shopId) return null;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        aria-label={
          cardData.notes && cardData.notes.length > 0
            ? `Notes: ${cardData.notes.length > 99 ? "99+" : cardData.notes.length}`
            : "Notes"
        }
        disabled={disabled && (cardData.notes?.length === 0 || !cardData.notes)}
        className={cn(
          "z-5 flex cursor-pointer items-center gap-0.5 rounded-full hover:bg-white/50",
          disabled &&
            (cardData.notes?.length === 0 || !cardData.notes) &&
            "cursor-default opacity-50"
        )}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {cardData.notes && cardData.notes.length > 0 ? (
          <Badge
            className="flex min-w-[1rem] items-center justify-center rounded px-0.5"
            variant={"default"}
            type={"small"}
          >
            {cardData.notes.length > 99 ? "99+" : cardData.notes.length}
          </Badge>
        ) : (
          <NotebookPenIcon size={iconSize} />
        )}
      </PopoverTrigger>
      <PopoverContent
        onMouseDown={(e) => e.stopPropagation()}
        className="flex max-h-[500px] w-96 flex-col gap-2 overflow-y-auto bg-card p-2"
      >
        {shopId && (
          <Notes
            shopId={shopId}
            cardData={cardData as Card}
            disabled={disabled}
          />
        )}
      </PopoverContent>
    </Popover>
  );
};
